import React from 'react';
import ReactDOM from 'react-dom';

import { OverlayContext } from './OverlayManager';

export default function Overlay({ children, modal, onKeyDown, onMouseDown }) {
  const manager = React.useContext(OverlayContext);
  const [node] = React.useState(() => {
    const div = document.createElement("div");
    div.className = "ui-Overlay";
    manager.addOverlay(div, modal);
    return div;
  });

  React.useEffect(() => {
    const listener = e => {
      manager.moveToTop(node);
    };
    node.addEventListener("mousedown", listener);
    return () => {
      node.removeEventListener("mousedown", listener);
      manager.removeOverlay(node);
    };
  }, [manager, node]);

  React.useEffect(() => {
    if (onMouseDown) {
      node.addEventListener("mousedown", onMouseDown);
      return () => node.removeEventListener("mousedown", onMouseDown);
    }
  }, [node, onMouseDown]);

  React.useEffect(() => {
    if (onKeyDown) {
      document.body.addEventListener("keydown", onKeyDown, true);
      return () => document.body.removeEventListener("keydown", onKeyDown, true);
    }
  }, [node, onKeyDown]);

  return ReactDOM.createPortal(children, node);
}
